import React from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';

import './_kendo-confirmation-dialog.scss';

interface KendoConfirmationDialogProps {
  title: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  messageStyle?: React.CSSProperties;
}

const KendoConfirmationDialog: React.FC<KendoConfirmationDialogProps> = ({
  title,
  message,
  onCancel,
  onConfirm,
  confirmText = 'Yes',
  cancelText = 'No',
  messageStyle
}) => {
  return (
    <Dialog title={title} onClose={onCancel} width={400} className="kendo-confirmation-dialog">
      <p style={{ margin: '20px', textAlign: 'center', ...messageStyle }}>{message}</p>
      <DialogActionsBar>
        <Button onClick={onCancel}>{cancelText}</Button>
        <Button themeColor="primary" onClick={onConfirm}>{confirmText}</Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default KendoConfirmationDialog;
